import { render, staticRenderFns } from "./memberLevel.vue?vue&type=template&id=68db0971&scoped=true"
import script from "./memberLevel.vue?vue&type=script&lang=js"
export * from "./memberLevel.vue?vue&type=script&lang=js"
import style0 from "./memberLevel.vue?vue&type=style&index=0&id=68db0971&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68db0971",
  null
  
)

export default component.exports